import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import IBM Plex Sans font weights
import '@fontsource/ibm-plex-sans/400.css'; // Regular 400
import '@fontsource/ibm-plex-sans/700.css'; // Bold 700

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
